// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file artifacts/analyzer/v1/analyzer_service.proto (package artifacts.analyzer.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AnalysisResult } from "../../../controls/v1/analysis_result_pb";
import { file_controls_v1_analysis_result } from "../../../controls/v1/analysis_result_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file artifacts/analyzer/v1/analyzer_service.proto.
 */
export const file_artifacts_analyzer_v1_analyzer_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_controls_v1_analysis_result]);

/**
 * @generated from message artifacts.analyzer.v1.ListSubcategoriesRequest
 */
export type ListSubcategoriesRequest = Message<"artifacts.analyzer.v1.ListSubcategoriesRequest"> & {
};

/**
 * Describes the message artifacts.analyzer.v1.ListSubcategoriesRequest.
 * Use `create(ListSubcategoriesRequestSchema)` to create a new message.
 */
export const ListSubcategoriesRequestSchema: GenMessage<ListSubcategoriesRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 0);

/**
 * @generated from message artifacts.analyzer.v1.ListSubcategoriesResponse
 */
export type ListSubcategoriesResponse = Message<"artifacts.analyzer.v1.ListSubcategoriesResponse"> & {
  /**
   * @generated from field: repeated artifacts.analyzer.v1.CategoryMetadata categories = 1;
   */
  categories: CategoryMetadata[];
};

/**
 * Describes the message artifacts.analyzer.v1.ListSubcategoriesResponse.
 * Use `create(ListSubcategoriesResponseSchema)` to create a new message.
 */
export const ListSubcategoriesResponseSchema: GenMessage<ListSubcategoriesResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 1);

/**
 * @generated from message artifacts.analyzer.v1.CategoryMetadata
 */
export type CategoryMetadata = Message<"artifacts.analyzer.v1.CategoryMetadata"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * @generated from field: string subcategory = 3;
   */
  subcategory: string;
};

/**
 * Describes the message artifacts.analyzer.v1.CategoryMetadata.
 * Use `create(CategoryMetadataSchema)` to create a new message.
 */
export const CategoryMetadataSchema: GenMessage<CategoryMetadata> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 2);

/**
 * @generated from message artifacts.analyzer.v1.UpdateArtifactSubcategoryRequest
 */
export type UpdateArtifactSubcategoryRequest = Message<"artifacts.analyzer.v1.UpdateArtifactSubcategoryRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string sub_category_id = 2;
   */
  subCategoryId: string;
};

/**
 * Describes the message artifacts.analyzer.v1.UpdateArtifactSubcategoryRequest.
 * Use `create(UpdateArtifactSubcategoryRequestSchema)` to create a new message.
 */
export const UpdateArtifactSubcategoryRequestSchema: GenMessage<UpdateArtifactSubcategoryRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 3);

/**
 * @generated from message artifacts.analyzer.v1.UpdateArtifactSubcategoryResponse
 */
export type UpdateArtifactSubcategoryResponse = Message<"artifacts.analyzer.v1.UpdateArtifactSubcategoryResponse"> & {
};

/**
 * Describes the message artifacts.analyzer.v1.UpdateArtifactSubcategoryResponse.
 * Use `create(UpdateArtifactSubcategoryResponseSchema)` to create a new message.
 */
export const UpdateArtifactSubcategoryResponseSchema: GenMessage<UpdateArtifactSubcategoryResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 4);

/**
 * @generated from message artifacts.analyzer.v1.RunPromptOnCompanyRequest
 */
export type RunPromptOnCompanyRequest = Message<"artifacts.analyzer.v1.RunPromptOnCompanyRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt: string;

  /**
   * @generated from field: repeated string subcategory_allow_list_ids = 3;
   */
  subcategoryAllowListIds: string[];

  /**
   * @generated from field: repeated string search_queries = 4;
   */
  searchQueries: string[];
};

/**
 * Describes the message artifacts.analyzer.v1.RunPromptOnCompanyRequest.
 * Use `create(RunPromptOnCompanyRequestSchema)` to create a new message.
 */
export const RunPromptOnCompanyRequestSchema: GenMessage<RunPromptOnCompanyRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 5);

/**
 * @generated from message artifacts.analyzer.v1.RunPromptOnCompanyResponse
 */
export type RunPromptOnCompanyResponse = Message<"artifacts.analyzer.v1.RunPromptOnCompanyResponse"> & {
  /**
   * @generated from field: controls.v1.AnalysisResult analysis_result = 1;
   */
  analysisResult?: AnalysisResult;
};

/**
 * Describes the message artifacts.analyzer.v1.RunPromptOnCompanyResponse.
 * Use `create(RunPromptOnCompanyResponseSchema)` to create a new message.
 */
export const RunPromptOnCompanyResponseSchema: GenMessage<RunPromptOnCompanyResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 6);

/**
 * @generated from message artifacts.analyzer.v1.ForceAnalyzeControlRequest
 */
export type ForceAnalyzeControlRequest = Message<"artifacts.analyzer.v1.ForceAnalyzeControlRequest"> & {
  /**
   * @generated from field: string org_control_definition_id = 2;
   */
  orgControlDefinitionId: string;

  /**
   * @generated from field: string org_ongoing_assessment_id = 3;
   */
  orgOngoingAssessmentId: string;
};

/**
 * Describes the message artifacts.analyzer.v1.ForceAnalyzeControlRequest.
 * Use `create(ForceAnalyzeControlRequestSchema)` to create a new message.
 */
export const ForceAnalyzeControlRequestSchema: GenMessage<ForceAnalyzeControlRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 7);

/**
 * Returns immediately after triggering analysis
 * Results will be saved to org_control_responses
 *
 * @generated from message artifacts.analyzer.v1.ForceAnalyzeControlResponse
 */
export type ForceAnalyzeControlResponse = Message<"artifacts.analyzer.v1.ForceAnalyzeControlResponse"> & {
};

/**
 * Describes the message artifacts.analyzer.v1.ForceAnalyzeControlResponse.
 * Use `create(ForceAnalyzeControlResponseSchema)` to create a new message.
 */
export const ForceAnalyzeControlResponseSchema: GenMessage<ForceAnalyzeControlResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 8);

/**
 * @generated from message artifacts.analyzer.v1.ReanalyzeAssessmentControlsRequest
 */
export type ReanalyzeAssessmentControlsRequest = Message<"artifacts.analyzer.v1.ReanalyzeAssessmentControlsRequest"> & {
  /**
   * @generated from field: string org_ongoing_assessment_id = 1;
   */
  orgOngoingAssessmentId: string;
};

/**
 * Describes the message artifacts.analyzer.v1.ReanalyzeAssessmentControlsRequest.
 * Use `create(ReanalyzeAssessmentControlsRequestSchema)` to create a new message.
 */
export const ReanalyzeAssessmentControlsRequestSchema: GenMessage<ReanalyzeAssessmentControlsRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 9);

/**
 * @generated from message artifacts.analyzer.v1.ReanalyzeAssessmentControlsResponse
 */
export type ReanalyzeAssessmentControlsResponse = Message<"artifacts.analyzer.v1.ReanalyzeAssessmentControlsResponse"> & {
  /**
   * @generated from field: int32 controls_queued = 1;
   */
  controlsQueued: number;
};

/**
 * Describes the message artifacts.analyzer.v1.ReanalyzeAssessmentControlsResponse.
 * Use `create(ReanalyzeAssessmentControlsResponseSchema)` to create a new message.
 */
export const ReanalyzeAssessmentControlsResponseSchema: GenMessage<ReanalyzeAssessmentControlsResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 10);

/**
 * @generated from service artifacts.analyzer.v1.AnalyzerService
 */
export const AnalyzerService: GenService<{
  /**
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.ListSubcategories
   */
  listSubcategories: {
    methodKind: "unary";
    input: typeof ListSubcategoriesRequestSchema;
    output: typeof ListSubcategoriesResponseSchema;
  },
  /**
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.UpdateArtifactSubcategory
   */
  updateArtifactSubcategory: {
    methodKind: "unary";
    input: typeof UpdateArtifactSubcategoryRequestSchema;
    output: typeof UpdateArtifactSubcategoryResponseSchema;
  },
  /**
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.RunPromptOnCompany
   */
  runPromptOnCompany: {
    methodKind: "unary";
    input: typeof RunPromptOnCompanyRequestSchema;
    output: typeof RunPromptOnCompanyResponseSchema;
  },
  /**
   * Support-only: queue analysis of a specific control, bypassing scope/enabled checks
   *
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.ForceAnalyzeControl
   */
  forceAnalyzeControl: {
    methodKind: "unary";
    input: typeof ForceAnalyzeControlRequestSchema;
    output: typeof ForceAnalyzeControlResponseSchema;
  },
  /**
   * Support-only: queue analysis of every enabled LLM control of an open assessment
   *
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.ReanalyzeAssessmentControls
   */
  reanalyzeAssessmentControls: {
    methodKind: "unary";
    input: typeof ReanalyzeAssessmentControlsRequestSchema;
    output: typeof ReanalyzeAssessmentControlsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_artifacts_analyzer_v1_analyzer_service, 0);

